import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { exploreCourseActions } from "../slices";

function* exploreCourseWorker({ payload }) {
  yield put(exploreCourseActions.pending());
  try {
    const response = yield call(courseAPI.exploreCourse, payload);
    yield put(exploreCourseActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(exploreCourseActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { exploreCourseWorker };
